import React, { useEffect, useState } from 'react'

export default function useDeviceIos() {
    const [deviceIos, setDeviceIos] = useState<boolean>(false)

    useEffect(() => {
        const userAgent = navigator.userAgent || navigator.vendor;
        // console.log(userAgent, "userAgent")

        if (/iPad|iPhone|iPod/.test(userAgent)) {
            setDeviceIos(true)
            // console.log('device is ios')
        }

    }, [])


    return deviceIos
}
